import styled from "styled-components";
import { FLEX } from "styles/flex";
import TableButton from "components/atoms/buttons/TableButton";
import UploadInput from "components/atoms/input/upload/UploadInput";
import { COLORS, LIGHT_THEME_COLORS } from "styles/colors";
import { ForwardedRef, forwardRef } from "react";

interface MapUploadProps {
  onUpload: (e?: any) => void;
  onDelete?: () => void;
  ref?: ForwardedRef<HTMLInputElement>;
  value?: any;
  isDeleteDisabled?: boolean;
  accept?: string;
}

const MapUpload = forwardRef(
  (
    {
      onUpload,
      onDelete,
      isDeleteDisabled,
      accept = "image/png, image/jpg, image/jpeg",
    }: MapUploadProps,
    ref: ForwardedRef<HTMLInputElement>
  ): JSX.Element => {
    return (
      <Wrapper>
        <Row>
          <UploadInput
            type="file"
            id="files"
            accept={accept}
            onChange={onUpload}
            ref={ref}
            data-testid="atoms-input-map-files-upload"
          />

          <TableButton
            buttonType="cancel"
            label="Upload"
            onClick={() => {
              if (ref && "current" in ref) {
                ref.current?.click();
              }
            }}
            data-testid="atoms-input-map-table-button-click"
          />
        </Row>
        {onDelete && (
          <TableButton
            buttonType="warning"
            label="Delete"
            onClick={onDelete}
            disabled={isDeleteDisabled}
            data-testid="atoms-input-map-table-button-delete"
          />
        )}
      </Wrapper>
    );
  }
);

const Wrapper = styled.div`
  ${FLEX.FlexStartCenter};
  width: 100%;
  gap: 10px;
  button,
  p {
    padding: 10px;
  }
`;

const Row = styled.label`
  ${FLEX.FlexBetweenCenter};
  gap: 10px;
  flex: 1;

  > p {
    background-color: ${({ theme }) =>
      theme.value === "light"
        ? LIGHT_THEME_COLORS.LIGHTGRAYBORDER
        : COLORS.BUTTONS1};
    border-radius: 4px;
    cursor: pointer;
  }
`;

export const MapUploadImage = styled.div`
  width: 100%;
  height: 200px;
  border: 1px solid #cacaca;
  > img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

export default MapUpload;
